import fetchClient from "./fetchClient";
import { getEnvironment360BizURL, getFetchApiOptions, ApiConfig } from '../configs/appConfig';
import { getHeaders } from "./dataService";

export interface AccessCodeResult {
    Recno: number;
    Code: string;
    Description: string;
    CodeAndDescription: string;
    DefaultParagraphRecno: number;
    IsParagraphRequired: boolean;
}

export interface LawCodeResult {
    Recno: number;
    Code: string;
    Description: string;
}

export interface AccessGroupResult {
    Recno: number;
    Name: string;
    IsPublic: boolean;
}

export const getAccessCodes = async (documentArchive: number): Promise<AccessCodeResult[]> => {
    const headers = await getHeaders();
    try {
        return await fetchClient(getEnvironment360BizURL() +
            ApiConfig.GetAccessCodes, {
            headers: headers,
            body: JSON.stringify({ documentArchive: documentArchive }),
            method: "POST",
            ...getFetchApiOptions()
        }) as AccessCodeResult[];

    } catch (err) {
        throw new Error("Error fetching access codes: " + String(err));
    }
};

export const getLawCodeTableResults = async (accessCode: number): Promise<LawCodeResult[]> => {
    const headers = await getHeaders();
    try {
        return await fetchClient(getEnvironment360BizURL() +
            ApiConfig.GetLawCodeTableResults, {
            headers: headers,
            body: JSON.stringify({ accessCode: accessCode }),
            method: "POST",
            ...getFetchApiOptions()
        }) as LawCodeResult[];

    } catch (err) {
        throw new Error("Error fetching law code table results: " + String(err));
    }
};

export const getAccessGroups = async (documentArchive: number, accessCode: number): Promise<AccessGroupResult[]> => {
    const headers = await getHeaders();
    try {
        return await fetchClient(getEnvironment360BizURL() +
            ApiConfig.GetAccessGroups, {
            headers: headers,
            body: JSON.stringify({ documentArchive: documentArchive, accessCode: accessCode }),
            method: "POST",
            ...getFetchApiOptions()
        }) as AccessGroupResult[];

    } catch (err) {
        throw new Error("Error fetching access groups: " + String(err));
    }
};
